import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PencilButtonComponent } from 'src/app/standalones/components/pencil-button/pencil-button.component';
import {
  IconConfig,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { MatDividerModule } from '@angular/material/divider';
import { ScreenSizeService } from 'src/app/services/screen-size.service';

@Component({
  selector: 'app-pencil-menu-item[label]',
  standalone: true,
  imports: [CommonModule, PencilButtonComponent, MatDividerModule, PencilIconComponent],
  templateUrl: './pencil-menu-item.component.html',
  styleUrls: ['./pencil-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PencilMenuItemComponent {
  @Input() label?: string;
  @Input() icon?: string;
  @Input() iconConfig?: IconConfig;
  @Input() selected: boolean = false;
  @Input() disabled: boolean = false;
  @Input() badge: boolean = false;
  @Input() forMenu: boolean = false;
  @Input() endSideContent: boolean = false;
  @Input() proBadge: boolean = false;
  @Input() isMenuOpened = false;
  @Input() subtitle?: string;
  @Input() betaBadge = false;
  @Input() showSpinner = false;
  @Input() renderCheckIcon = false;
  @Input() set isDanger(value: boolean) {
    this.dangerStyle = value;
  }

  @Output() clickEvent = new EventEmitter<Event>();
  @Output() mouseEnterEvent = new EventEmitter<Event>();
  @Output() mouseLeaveEvent = new EventEmitter<Event>();

  @HostBinding('class.danger') dangerStyle = false;

  renderedInBottomSheet$ = this.screenSizeService.renderMenuAsBottomSheet$;

  constructor(private screenSizeService: ScreenSizeService) {}

  handleClick(event: Event): void {
    if (this.disabled) {
      return;
    }

    this.clickEvent.emit(event);
  }

  handleMouseEnter(event: Event): void {
    this.mouseEnterEvent.emit(event);
  }

  handleMouseLeave(event: Event): void {
    this.mouseLeaveEvent.emit(event);
  }

  preventEventPropagationIfDisabled(event: Event): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
